<template>
    <nav class="navbar navbar-expand-lg navbar-light py-0" id="navbarPrincipal"  style="padding: .01rem auto;">
        <div id="anchoNav" class="container" v-scroll-reveal="{scale:2}">
            <div id="logoHacienda_div">
                <a id="logoHacienda" class="nav-link py-2" style="padding-left:0" href="/SitioNuevo/"> <!-- :href="UrlHome"--->
                    <span class="bold">SECRETARÍA</span> <br><span class="bold">DE FINANZAS</span><br>
                </a>
            </div>

            <button style="color:#ffffff !important;" class="navbar-toggler text-white" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <!-- <span class="navbar-toggler-icon text-white"></span> -->
            <i class="fas fa-bars"></i>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent" style="justify-content:flex-end">
                <ul class="navbar-nav">
                    <li class="nav-item" @click="ocultar()">
                        <router-link class="nav-link" :to="{name: 'secretaria-de-finanzas'}">CONÓCENOS</router-link>
                    </li>
                    <li class="nav-item" @click="ocultar()">
                         <router-link class="nav-link" :to="{name: 'municipal'}">LEGISLACIÓN</router-link>
                    </li>
                    <li class="nav-item" @click="ocultar()">
                         <a :href="'http://www.ingresos.'+urlSubdominio" target="_blank" class="nav-link" >SERVICIOS AL CONTRIBUYENTE</a>
                    </li>
                    <li class="nav-item" @click="ocultar()">
                        <!-- <router-link class="nav-link" to="/rendicion-de-cuentas">RENDICIÓN DE CUENTAS</router-link> -->
                        <router-link class="nav-link" :to="{name: 'Menu'}">RENDICIÓN DE CUENTAS</router-link>
                    </li>
                    <li class="nav-item" @click="ocultar()">
                        <!-- <router-link class="nav-link" :to="{name: 'tramites-servicios'}">TRÁMITES Y SERVICIOS</router-link> -->
                        <a class="nav-link" target="_blank" href="https://www.chiapas.gob.mx/servicios-por-entidad/uadministrativas.php?id=3178&dependencia=Secretaría%20de%20Hacienda">TRÁMITES Y SERVICIOS</a>
                    </li>
                    <li class="nav-item" @click="ocultar()">
                        <router-link class="nav-link" :to="{name: 'planeacion'}">PLANEACIÓN</router-link>
                    </li>
                    <!-- <li class="nav-item" @click="ocultar()">
                         <router-link class="nav-link" to="/funcionarios">FUNCIONARIOS</router-link>
                    </li> -->
                    <li class="nav-item" @click="ocultar()">
                        <!-- <router-link class="nav-link" to="/transparencia">TRANSPARENCIA</router-link> -->
                        <a :href="'http://www.transparencia.' + urlSubdominio" target="_blank" class="nav-link">TRANSPARENCIA</a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
 // id = navbarSupportedContent |  class = collapse navbar-collapse

export default {
    computed:{
        UrlHome(){ return window.location.pathname; }
    },
    methods:{
        ocultar(){ document.getElementById("navbarSupportedContent").className = "collapse navbar-collapse"; }
    }
}
</script>
<style scoped>
    .spacing, .bold {font-size:.9rem;}
    #navbarSupportedContent ul li a { font-size: .66rem; }
</style>
